// extracted by mini-css-extract-plugin
export default {"buyOpensea":"SimulatorBuyTraitOpenseaButton_buyOpensea__0sgN7","loading":"SimulatorBuyTraitOpenseaButton_loading__8gfA5"};